import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Settings = apiContainer.Settings
//GET--->
// Corrected getSettings function
export async function getSettingsApi(request) {
    // let findObj = findObject(request);
    try {
        return api.get(`${Settings}`, {});
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createSettings(request) {
    try {
        return api.createWithFile(`${Settings}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateSettings(request, SettingsId) {
    try {
        return api.updateWithFile(`${Settings}/${SettingsId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteSettings(SettingsId) {
    try {
        return api.delete(`${Settings}/${SettingsId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



